<template>
  <md-dialog :md-click-outside-to-close="true" :md-active.sync="showDialog">
    <div class="s1-loc__progress-spinner-wrapper" v-show="loading">
      <md-progress-spinner class="md-accent" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <md-dialog-title>
      <div class="s1-U__full-width">
        <h3 class="md-display-1 s1-U__text-color--primary">{{ $t('change_email') }}</h3>
      </div>
    </md-dialog-title>
    <md-dialog-content style="max-width: 368px">
      <div class="s1-loc__md-field-wrapper s1-U__width--300px">
        <md-field :class="{'md-invalid s1-U__mg--bt48' : invalidEmail}">
          <label>{{ $t('email') }}</label>
          <md-input @input="checkEmail(email); disableButtonAction()" v-model="email"/>
          <span class="md-error" v-if="invalidEmail">{{ $t('field.invalid') }}</span>
        </md-field>
        <p v-if="olderEmail.toLowerCase() === email.toLowerCase()" class="md-caption s1-U__mg--bt32">{{ $t('older_email_equals') }}</p>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="s1-U__pd16">
      <md-button type="button" class="md-raised" @click="close(false)">{{ $t('cancel') }}</md-button>
      <md-button
        type="button"
        class="md-primary md-raised"
        @click="save"
        :disabled="disableButton"
      >{{ $t('btn.save_new_email') }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script type="ts">
import {email} from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

export default {
    mixins: [validationMixin],
    validations: {
      email: {email}
    },
    props: {
      id: String,
      olderEmail: String
    },
    data: () => ({
      email: '',
      showDialog: false,
      loading: false,
      error: '',
      disableButton: true,
      invalidEmail: false
  }),
  methods: {
    open() {
      this.loading = false;
      this.error = null;
      this.showDialog = true;
    },

    close(changed) {
      this.showDialog = false;
      this.loading = false;
      this.$emit('close', changed);
    },

    disableButtonAction() {
      if (!this.invalidEmail && this.email && this.olderEmail.toLowerCase() != this.email.toLowerCase())
        this.disableButton = false;
      else this.disableButton = true;
    },

    checkEmail(email){
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          this.invalidEmail = false;
      } else {
        this.invalidEmail = true;
      }
    },

    goTovalidateMfa(secret) {
      this.$router.push(`validate-mfa?secret=${secret}&origin=register&returnUrl=${process.env.VUE_APP_ACCOUNTS}`);
    },

    save(){
      this.$axios
          .post(`${process.env.VUE_APP_AUTH_URL}api/v1/hotp/generate?api-version=1.0`,
          { userId: this.id, email: this.email})
          .then(
            (result) => {
              localStorage.setItem('email', this.email);
              localStorage.setItem('userId', this.id);
              this.goTovalidateMfa(result.data);
            },
            (error) => {
              this.error = error;
              this.loading = false;
            }
          );
    }
  }
}
</script>